import { useState, useEffect } from 'react'

import IdmReactTable from "common/IdmReactTable"

import DeleteConfirmModal from 'common/ConfirmModal'
import { QueryResultsStyles, AdminButtonWrap } from 'admin/QueryStyles'
import { formatDate, formatPhone } from 'admin/adminutil'
import { FilledYellow } from 'css/Buttons'
import AdminDeleteIcon from 'images/x-red.svg'

import { adminDownloadDocument, deleteDocument, saveDocument } from '../mggadminutil'
import css from '../sass/confirm.modal.module.scss'
import deleteIcon from '../../images/trash-can-icon.png';
import downloadIcon from '../../images/download-icon.png';


const getLegacyEiarNames = fileName => {
  const [lastName = '', firstName = ''] = (fileName || '').split('.')

  return { firstName, lastName }
}

const getEiarName = row => {
  const legacyNames = getLegacyEiarNames(row.FileName)
  const firstName = row.FirstName || legacyNames.firstName
  const lastName = row.LastName || legacyNames.lastName

  return `${firstName} ${lastName}`.trim()
}


function DocumentSearchResults(props) {
  const isReadOnlyAdmin = localStorage.isDpReadOnlyAdmin === "true" && localStorage.isDpAdmin !== "true"
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showBlockedModal, setShowBlockedModal] = useState(false)
  const [docToEdit, setDocToEdit] = useState(null)
  const [indexToEdit, setIndexToEdit] = useState(null)
  const [blockedCrmIds, setBlockedCrmIds] = useState(null)

  const tableProps = {
    initialState: {
      sortBy: [
       {
        id: 'ReportYear',
        desc: true
       }
      ]
    },
  }

  const displayBlockedCrmIds =  ({ row })  => {
    if (isReadOnlyAdmin) {
      return row.original.BlockedCrmIds && row.original.BlockedCrmIds.length > 0
        ? <span>{row.original.BlockedCrmIds.join(", ")}</span>
        : null
    }

    if (row.original.ReportType === 'EIAR' || row.original.ReportSubType === 'User') {
      return null;
    }
    else if (row.original.BlockedCrmIds && row.original.BlockedCrmIds.length > 0) {
      return (<span title='Edit blocked CRM IDs' className={css.rowIcon} onClick={e => editBlockedCrmIds(row.original)}>{row.original.BlockedCrmIds.join(", ")} <strong>&#x270E;</strong></span>)
    }
    else {
      return (<span title='Add blocked CRM IDs' className={css.rowIcon} onClick={e => editBlockedCrmIds(row.original)}>&#10133;</span>)
    }
  }

  const displayDownloadIcon = ({ row }) => (
    <center className={css.rowIcon}><img width="25" height="25" title='DOWNLOAD' alt='' src={downloadIcon}
            onClick={e => adminDownloadDocument(row.original)} /></center>
  )

  const displayDeleteIcon = ({ row }) => {
    if (!row.original.FileName) return null

    return (
      <center className={css.rowIcon}><img width="25" height="25" title='DELETE' alt='' src={deleteIcon}
              onClick={e => confirmDeleteDocument(row.original, row.index)} /></center>
    )
  }

  const displayFileNames = row => {
    if (row.FileName) return row.FileName
    return Array.isArray(row.FileNames) ? row.FileNames.join(', ') : row.FileNames || ''
  }

  const mainTableColumns = {
    AllDocuments: [
      { Header: 'Year', desc: false, accessor: 'ReportYear'},
      { Header: 'Type', desc: false, name: 'Type', accessor: row => row.ReportSubType ? row.ReportType + '/' + row.ReportSubType : row.ReportType},
      { Header: 'ID or #', name: 'FundNumber', accessor: row => row.ReportNumber || row.CrmId || row.ReportId},
      { Header: 'FILE NAME(S)', name: 'FileNames', desc: true, accessor: displayFileNames},
      { Header: 'Blocked CRM IDs', name: 'BlockedCrmIds', desc: true, Cell: displayBlockedCrmIds},
      { Header: ' ', desc: true, Cell: displayDownloadIcon },
      { Header: '  ', name: 'Delete', desc: true, Cell: displayDeleteIcon },
    ],
    EIAR: [
      { Header: 'Year', desc: false, accessor: 'ReportYear'},
      { Header: 'Type', desc: false, name: 'Type', accessor: 'ReportType'},
      { Header: 'CRM ID', desc: false, accessor: 'CrmId'},
      { Header: 'Name', desc: false, name: 'Name', accessor: getEiarName},
      { Header: 'FILE NAME(S)', name: 'FileNames', desc: true, accessor: displayFileNames},
      { Header: ' ', desc: true, Cell: displayDownloadIcon },
      { Header: '  ', name: 'Delete', desc: true, Cell: displayDeleteIcon },
    ],
    CEIR: [
      { Header: 'Year', desc: false, accessor: 'ReportYear'},
      { Header: 'Type', desc: false, name: 'Type', accessor: 'ReportType'},
      { Header: 'Fund #', desc: false, accessor: 'ReportNumber'},
      { Header: 'File Name', desc: true, accessor: 'FileName'},
      { Header: 'Blocked CRM IDs', name: 'BlockedCrmIds', desc: true, Cell: displayBlockedCrmIds},
      { Header: ' ', desc: true, Cell: displayDownloadIcon },
      { Header: '  ', name: 'Delete', desc: true, Cell: displayDeleteIcon },
    ],
    ACR: [
      { Header: 'Year', desc: false, accessor: 'ReportYear'},
      { Header: 'Type', desc: false, name: 'Type', accessor: row => row.ReportType + '/' + row.ReportSubType},
      { Header: 'ID or #', name: 'FundNumber', accessor: row => row.ReportNumber || row.CrmId || row.ReportId},
      { Header: 'File Name', desc: true, accessor: 'FileName'},
      { Header: 'Blocked CRM IDs', name: 'BlockedCrmIds', desc: true, Cell: displayBlockedCrmIds},
      { Header: ' ', desc: true, Cell: displayDownloadIcon },
      { Header: '  ', name: 'Delete', desc: true, Cell: displayDeleteIcon },
    ],
  }

  const displayTableColumns = mainTableColumns[props.documentType]
    .filter(column => !isReadOnlyAdmin || column.name !== 'Delete')

  const copyTableToClipboard = () => {
    const textToCopy = [displayTableColumns.map(c => c.Header).join('\t')];
    props.data.forEach(row => {
      textToCopy.push(displayTableColumns.map(c => {
        if (c.name === 'Type') {
          if (c.accessor === 'ReportType')
            return row[c.accessor] || ''
          else if (props.documentType === 'AllDocuments')
            return row.ReportSubType ? row.ReportType + '/' + row.ReportSubType : row.ReportType
          else
            return row.ReportType + '/' + row.ReportSubType
        }
        else if (c.name === 'FundNumber') {
          return "'" + (row.ReportNumber || row.CrmId || row.ReportId)
        }
        else if (c.name === 'BlockedCrmIds') {
          return row.BlockedCrmIds && row.BlockedCrmIds.length > 0 ? ("'" + row.BlockedCrmIds.join(", ")) : ''
        }
        else if (c.name === 'FileNames') {
          return displayFileNames(row)
        }
        else if (c.name === 'Name') {
          return getEiarName(row)
        }
        else {
          return row[c.accessor] || '';
        }
      })
      .join('\t'))
    })
    navigator.clipboard.writeText(textToCopy.join('\n'))
  }

  const confirmDeleteDocument = (doc, index) => {
    setDocToEdit(doc)
    setIndexToEdit(index)
    setShowDeleteModal(true)
  }

  const finishDeleteDocument = async (e) => {
    const deleteReponse = await deleteDocument(docToEdit)

    if (!deleteReponse || deleteReponse.error || deleteReponse.errorMessage) {
      let errorMessage = "There was an error deleting the document."
      if (deleteReponse)
        errorMessage = deleteReponse.errorMessage || deleteReponse.error || errorMessage
      alert(errorMessage.msg || errorMessage)
    }
    else {
      delete props.data[indexToEdit]
    }
    setShowDeleteModal(false)
  }

  const editBlockedCrmIds = (doc) => {
    setDocToEdit(doc)
    setBlockedCrmIds((doc.BlockedCrmIds || []).join(", "))
    setShowBlockedModal(true)
  }

  const updateBlockedCrmIds = (e) => {
    setBlockedCrmIds(e.target.value)
  }

  const saveEditedDocument = async (e) => {
    const blockedCrmIdString = blockedCrmIds.replace(/\s/g, '')
    docToEdit.BlockedCrmIds = blockedCrmIdString ? blockedCrmIdString.split(',') : []

    for (const crmId of docToEdit.BlockedCrmIds) {
      if (!/^\d{10}$/.test(crmId)) {
        alert('All CRM IDs must be 10 digits')
        return
      }
    }

    const saveResponse = await saveDocument(docToEdit)

    if (!saveResponse || saveResponse.error || saveResponse.errorMessage)
      alert('There was an error saving this document ' + (saveResponse ? saveResponse.error || saveResponse.errorMessage : ''))

    setShowBlockedModal(false)
  }

  // if (props.data.length > 2) {
  //   props.data[0].BlockedCrmIds=["0123456789", "0123456789", "0123456789", "0123456789", "0123456789", "0123456789", "0123456789", "0123456789", "0123456789"]
  //   props.data[1].BlockedCrmIds=["0123456789"]
  //   props.data[2].BlockedCrmIds=["0123456789", "0123456789", "0123456789"]
  // }

  return (
    <QueryResultsStyles searchType={props.documentType === 'EIAR' ? 'eiarDocuments' : 'documents'}>
      {props.data.length > 0 &&
        <IdmReactTable
          { ...tableProps }
          data={ props.data }
          columns={ displayTableColumns }
        />}

       {showDeleteModal &&
        <DeleteConfirmModal
          onConfirm={finishDeleteDocument}
          onCancel={() => setShowDeleteModal(false)}
          cancelText={"CANCEL"}
          confirmText={"OK"}
        >
          <div className={css.modalInner}>
            <div><img src={AdminDeleteIcon} alt='Delete Document icon'/></div>
            <div className={css.modalText}>
              Are you sure you want to delete the file:
              <br/><strong>{docToEdit.FileName}</strong>?
            </div>
          </div>
        </DeleteConfirmModal>
      }

       {showBlockedModal &&
        <DeleteConfirmModal
          onConfirm={saveEditedDocument}
          onCancel={() => setShowBlockedModal(false)}
          cancelText={"CANCEL"}
          confirmText={"SAVE"}
        >
          <div className={css.modalInner}>
            <div className={css.modalText}>
              CRM IDs to block for <b>{docToEdit.FileName}:</b>
              <br/><textarea cols="100" rows="4" name="blockedCrmIds"
                             onChange={updateBlockedCrmIds}
                             value={blockedCrmIds}
                             className="blocked-crm-ids"></textarea>
              <br/><p>(separate CRM IDs with commas, whitespace is ignored)</p>
            </div>
          </div>
        </DeleteConfirmModal>
      }

     <section>
        <div>
          <span>Total Results: </span>{props.data.length}
          {props.data.length > 0 &&
            <AdminButtonWrap>
              <FilledYellow
                width="7.0625rem"
                bgColor={"#FFD100"}
                fontColor={"#005587"}
                borderColor={"#FFD100"}
                name={props.btnName}
                onClick={copyTableToClipboard}
              >
                <span>Copy to Clipboard</span>
              </FilledYellow>
            </AdminButtonWrap>}

        </div>
      </section>
    </QueryResultsStyles>
  )
}

export default DocumentSearchResults
